<!-- <div class="row m-4">
  <div class="col-md-3">
    <app-navbar></app-navbar>
  </div>
  <div class="col-md-4">
    <h1 class="center">
      <i class="fa fa-server"
        style="margin-right: 6px;color: rgb(202,1,1);font-size: 28px;"></i>Administrator
    </h1>
  </div>
</div> -->

<div class="container-fluid mt-md-3">
  <h1><i class="fa fa-users text-danger mr-1"></i> Markets Data</h1>
  <hr>
  <div class="row">
    <div class="col-md-8">
      <div>
        <mat-spinner *ngIf="fetchingData"></mat-spinner>
      </div>
      <div class="mb-5" *ngIf="market_locations.length>0 && !fetchingData" style="max-height:90vh;overflow-y:auto;">


        <div class="col-sm-12">
          <mat-form-field class="col-lg-10">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Filter value">
          </mat-form-field>
            <button class="example-button-row col-lg-2 " mat-raised-button
            style="background-color: #3f51b5;color: white;" [routerLink]="['new']">Insert market</button>
        </div>


        <table mat-table [dataSource]="tableData" class="mat-elevation-z8 col-sm-12">

          <ng-container matColumnDef="marketId">
            <th mat-header-cell *matHeaderCellDef class="px-2"> ID </th>
            <td mat-cell *matCellDef="let element;index as i"  class="px-2"> {{i+1}} </td>
          </ng-container>

          <ng-container matColumnDef="marketName">
            <th   mat-header-cell *matHeaderCellDef> Market Name </th>
            <td  mat-cell *matCellDef="let element"> {{element.market_name}} </td>
          </ng-container>

          <ng-container matColumnDef="locationName">
            <th   mat-header-cell *matHeaderCellDef> Location Name </th>
            <td  mat-cell *matCellDef="let element" class="text-center"> {{element.location_name}} </td>
          </ng-container>

          <ng-container matColumnDef="emailAdd"  >
            <th mat-header-cell *matHeaderCellDef > Email Address </th>
            <td mat-cell *matCellDef="let element" class="text-center"> {{element.email_address}} </td>
          </ng-container>

          <ng-container matColumnDef="remedySupportGroup">
            <th mat-header-cell *matHeaderCellDef> Remedy Support Group </th>
            <td mat-cell *matCellDef="let element"> {{element.remedy_support_group}} </td>
          </ng-container>

          <ng-container matColumnDef="remedyTicketSummary">
            <th mat-header-cell *matHeaderCellDef> Remedy Ticket Summary </th>
            <td mat-cell *matCellDef="let element" class="text-center"> {{element.remedy_ticket_summary}} </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> <i class="fa fa-cogs fa-2x" ></i></th>
            <td mat-cell *matCellDef="let element">
              <div >
                <button mat-raised-button  color="primary"  class="dropdown-toggle m-1"
                 type="button" id="dropdownMenuButton" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  Actions
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <button mat-stroked-button color="primary" class="dropdown-item"
                   (click)="sendMarketToChildComponent_update(element)">
                  <!-- <button mat-stroked-button color="primary" class="dropdown-item"
                   (click)="sendUserToChildComponent(element)" [routerLink]="[element.id,'edit']"> -->
                   Update
                  </button>
                  <button mat-stroked-button color="warn"
                  class="dropdown-item" (click)="openDialog(element.id)">Delete</button>
                  <!-- <button mat-stroked-button color="warn" [disabled]="element.user_role=='admin'"
                  class="dropdown-item" (click)="openDialog(element.id)">Delete</button> -->
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>


      </div>
      <div *ngIf="market_locations.length==0 && !fetchingData">
        <div class="example-button-row">
          <button class="m-1" mat-raised-button style="background-color: green;color: white;"
          [routerLink]="['new']">Insert new market</button>
        </div>
        <p>No data available</p>
      </div>
    </div>
    <div class="col-md-4" *ngIf="!fetchingData">
      <h2 class="text-capitalize font-weight-bold "><i class="fa fa-address-card text-danger mr-1"></i>Choose<span class="text-lowercase"> a market to update or insert new market</span></h2>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>





<!-- <button class="m-1" mat-raised-button style="background-color: green;color: white;"
(click)="openDialog2()">Open search dialog</button> -->

